import merchants from "../services/merchants";
import notification from "../services/notification";
import _ from "lodash";

const mutations = {
    reset(state) {
        state.detailsUpdated = false;
        state.applicationsUpdated = false;
        state.loading = false;
        state.message = null;
        state.errors = {};
    },
    details(state, response) {
        state.details = response;
        state.loading = false;
    },
    documents(state, documents) {
        _.each(documents, (item, key) => {
            item.new = null;
            item.upload = null;
            documents[key] = item;
        });

        state.documents = documents;
        state.loading = false;
    },
    loading(state) {
        state.loading = true;
        state.message = null;
        state.errors = {};
    },
    errors(state, errors) {
        state.errors = errors;
        state.loading = false;
    },
    detailsUpdated(state, details) {
        state.detailsUpdated = true;
        state.details = details;
    },
    documentsUpdated(state, documents) {
        state.documentsUpdated = true;
        state.documents = documents;
    },
    applications(state, applications) {
        state.applications = applications;
        state.loading = false;
    },
    applicationsUpdated(state, applications) {
        state.applicationsUpdated = true;
        state.applications = applications;
    },
    setMeta(state, meta) {
        state.meta = meta;
        state.loading = false;
    },
    SET_MAINTENANCE(state, maintenance) {
        state.maintenance = maintenance
    },
    setModuleList(state, payload) {
        state.moduleList = payload;
    }
};

const actions = {
    async getDetails({ commit }) {
        commit("loading");
        try {
            let response = await merchants.getDetails();
            commit("details", response);
        } catch (errors) {
            commit("errors", errors);
        }
    },

    async updateDetails({ commit }, payload) {
        commit("loading");
        try {
            let response = await merchants.updateDetails(payload);
            notification.success(response.message);
            commit("detailsUpdated", response.merchant);
        } catch (errors) {
            commit("errors", errors);
        }
    },

    async getDocuments({ commit }) {
        commit("loading");
        try {
            let response = await merchants.getDocuments();
            commit("documents", response);
        } catch (errors) {
            commit("errors", errors);
        }
    },

    async updateDocuments({ commit }, payload) {
        commit("loading");
        try {
            let response = await merchants.updateDocuments(payload);
            commit("documents", response);
        } catch (errors) {
            commit("errors", errors);
        }
    },

    async getApplicationDetails({ commit }) {
        commit("loading");
        try {
            let response = await merchants.getApplicationDetails();
            commit("applications", response);
        } catch (errors) {
            commit("errors", errors);
        }
    },

    async updateApplicationDetails({ commit }, payload) {
        commit("loading");
        try {
            let response = await merchants.updateApplicationDetails(payload);
            notification.success(response.message);
            commit("applicationsUpdated", response.merchant);
        } catch (errors) {
            commit("errors", errors);
        }
    },

    async viewMeta({ commit }, payload) {
        commit("loading");
        try {
            let response = await merchants.viewMeta(payload);
            commit("setMeta", response);
        } catch (errors) {
            commit("errors", errors);
        }
    },
    async updateMeta({ commit }, payload) {
        commit("loading");
        try {
            let response = await merchants.updateMeta(payload);
            commit(
                "setMeta",
                response.import_transaction_history_notifications
            );
        } catch (errors) {
            commit("errors", errors);
        }
    },

    async fetchMaintenance({ commit }) {
        return new Promise((resolve, reject) => {
            merchants.getMaintenance()
                .then(maintenances => {
                    const maintenance = maintenances.data.maintenance.find(m => m.status === "on_going")
                    commit("SET_MAINTENANCE", maintenance);
                    resolve();
                })
                .catch(() => reject());
        })
    },
    async getModuleList({ commit }) {
        commit("loading");

        try {
            const { modules } = await merchants.getModuleList();
            
            commit("setModuleList", modules);
        } catch (errors) {
            commit("errors", errors);
        }
    }
};

export default {
    namespaced: true,
    state: {
        errors: {},
        message: null,
        loading: false,
        details: {},
        documents: {
            loa: {},
            government_id: {},
            authorization_letter: {}
        },
        maintenance: null,
        applications: {},
        steps: [
            {
                img: require("../assets/images/setup/upload_1.svg"),
                label: "Upload necessary documents",
                desc:
                    "Fill in your company's basic information, authorize representative and upload documents related to your agreement in using the RUSH loyalty program."
            },
            {
                img: require("../assets/images/setup/upload_2.svg"),
                label: "Design your app",
                desc:
                    "Personalize your app look by providing the needed requirements below."
            },
            {
                img: require("../assets/images/setup/upload_3.svg"),
                label: "Manage your store",
                desc:
                    "Add different brands and branches of your company. You can also assign employee access per branch."
            },
            {
                img: require("../assets/images/setup/upload_4.svg"),
                label: "Create your mechanics",
                desc: "Customize your overall loyalty program mechanics."
            },
            {
                img: require("../assets/images/setup/upload_5.svg"),
                label: "Your apps are ready",
                desc: " "
            }
        ],
        meta: null,
        detailsUpdated: false,
        applicationsUpdated: false,
        moduleList: null
    },
    actions,
    mutations
};
